/**
 * Spostamento di un elemento dentro un elenco, per il riordino a trascinamento.
 *
 * Sta fuori dal componente perche' e' la parte che si sbaglia: gli indici dopo
 * la rimozione non sono piu' quelli di prima, e trascinare in avanti o
 * indietro non e' simmetrico.
 *
 * Restituisce un elenco nuovo: chi lo usa passa da un segnale, e mutare
 * l'array in posto non farebbe scattare l'aggiornamento.
 */
export function spostaVoce<T>(elenco: readonly T[], da: number, a: number): T[] {
  if (da < 0 || da >= elenco.length) return [...elenco];

  // La posizione di arrivo si intende sull'elenco di partenza: si lascia
  // finire dove si e' rilasciato, quindi si accetta anche `elenco.length`.
  const arrivo = Math.max(0, Math.min(a, elenco.length - 1));
  if (arrivo === da) return [...elenco];

  const copia = [...elenco];
  const [voce] = copia.splice(da, 1);
  copia.splice(arrivo, 0, voce);
  return copia;
}
